/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import DateFnsUtils from "@date-io/date-fns";
import CloseIcon from "@material-ui/icons/Close";
import { useDispatch } from "react-redux";
import {
  Button, Grid, IconButton, Modal,
} from "@material-ui/core";

import {
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { CheckedRadioGroup } from "../../../../shared/components/commonComponents/CheckedRadioGroup";
import { setOperatorsSettlementCycleAction } from "../../../../redux/action-creators/operatorSettlementConfig";

function OperatorConfigModal(props) {
  const dispatch = useDispatch();

  const {
    open, setOpen, getList, selected, selectedCity, setSelected, availableConfigs, rowData = {},
  } = props;

  const [settlementConfigData, setSettlementConfigData] = useState({
    settlementCycle: "",
  });

  const onChangeHandler = ({ target: { name, value } }) => {
    setSettlementConfigData({ ...settlementConfigData, [name]: value });
  };

  const handleClose = useCallback(() => {
    setOpen(!open);
  }, [open, setOpen]);

  const handleSave = useCallback(() => {
    dispatch(setOperatorsSettlementCycleAction({
      cityId: rowData?.cityId ? Number(rowData?.cityId) : Number(selectedCity?.cityId),
      operatorIdArr: rowData?.operatorId
        ? [Number(rowData?.operatorId)]
        : selected.map((item) => Number(item)),
      cycleType: settlementConfigData.settlementCycle,
    }));
    setOpen(!open);
    setSelected([]);
  }, [dispatch, getList, open, rowData?.cityId,
    rowData?.operatorId, setOpen, settlementConfigData.settlementCycle]);

  useEffect(() => {
    onChangeHandler({ target: { name: "settlementCycle", value: rowData?.cycleType } });
  }, []);

  return (
    <Modal open={open} onClose={handleClose} className="operator-config-modal">
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid
          className="operator-config-modal-body"
          container
          direction="column"
          spacing={5}
        >
          <Grid container item alignItems="flex-end" spacing={3}>
            <Grid item xs={10}>
              {Object.keys(rowData)?.length ? (
                <h3 className="operatorConfigHeading">
                  Edit Settlement Cycle
                </h3>
              ) : (
                <h3 className="operatorConfigHeading">
                  Select Settlement Cycle
                </h3>
              )}
            </Grid>
            <Grid row item xs={2} align="end">
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
          <Grid container item alignItems="flex-end" spacing={3}>
            <Grid item xs={12}>
              <CheckedRadioGroup
                options={availableConfigs.map((config) => ({ label: config, value: config }))}
                defaultValue={settlementConfigData.settlementCycle}
                onChangeHandler={onChangeHandler}
                name="settlementCycle"
              />
            </Grid>
          </Grid>
          <Grid container item spacing={3}>
            <Grid item xs={12} align="end">
              <Button
                variant="contained"
                className="operatorConfigCancel"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                className="operatorConfigSave"
                variant="outlined"
                onClick={handleSave}
                disabled={
                  !settlementConfigData.settlementCycle
                }
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    </Modal>
  );
}
export default OperatorConfigModal;
